import { get } from "./axiosApi";
import { env } from "utils/env";
import { objToQueryString } from "utils/functions";

const url = env.REACT_APP_LEASING_API_URL; //"http://kube-w1:32751/api";
const masterPartnerUrl = env.REACT_APP_LSNG_MASTERPARTNER_API_URL;

class DictionariesApi {
  static getCurrencies() {
    return get(url + "/currencies");
  }

  static getResponsibles(search='', partnerId = "") {
    return get(`${url}/responsibles?search=${search}&partnerId=${partnerId}`);
  }

  static getRiskResponsibles() {
    return get(`${url}/responsibles/risk-responsibles`);
  }

  static getActivityFields() {
    return get(`${url}/dictionary/activity-fields`);
  }

  static getBankAccountTypes() {
    return get(`${masterPartnerUrl}/dictionaries/bank-account-types`);
  }

  static getRiskAnalysisTypes(documentTypeId) {
    return get(`${url}/dictionary/risk-analysis-types/${documentTypeId}`);
  }

  static getAddressTypes() {
    return get(`${url}/dictionary/address-types`);
  }

  static getSignatureRoles() {
    return get(`${url}/dictionary/signature-roles`);
  }

  static getPriceTypes() {
    return get(`${url}/dictionary/price-types`);
  }
  static getVerificationTypes() {
    return get(`${url}/dictionary/verification-types`);
  }

  static getChecklists() {
    return get(`${url}/dictionary/checklist`);
  }

  static getInterestTypes() {
    return get(`${url}/dictionary/interest-types`);
  }

  static getGenderTypes = () => {
    return get(`${url}/dictionary/gender-types`);
  };

  static getResponsible(responsibleId) {
    return get(`${url}/responsibles/${responsibleId}`);
  }

  static getFinancingTypes() {
    return get(url + "/leasingoffers/financingTypes");
  }

  static getOfferTypes(documentTypeId) {
    return get(`${url}/leasingoffers/offerTypes/${documentTypeId}`);
  }

  static getStates(documentTypeId) {
    return get(`${url}/leasingdocument/states/${documentTypeId}`);
  }

  static getOfferVisibilityLevels() {
    return get(url + "/leasingoffers/visibilitylevels");
  }

  static getFolderVisibilityLevels() {
    return get(`${url}/leasingfolders/visibilitylevels`);
  }

  static getPartnerFileVisibilityLevels() {
    return get(`${url}/partner-files/visibility-levels`);
  }

  static getOfferDecisionTypes() {
    return get(url + `/leasingdocument/decisionTypes/`);
  }

  static getWarrantyTypes() {
    return get(url + `/leasingdocument/warrantytypes`);
  }

  static getSources() {
    return get(`${url}/leasingoffers/sourcetypes`);
  }
  static getChannels() {
    return get(url + "/leasingoffers/channeltypes");
  }

  static getApprovalTypes() {
    return get(url + "/leasingoffers/approvalTypes");
  }

  static getSuppliers(search) {
    return get(`${url}/suppliers?search=${search}`);
  }
 
  static getDealers(search) {
    return get(`${url}/dealers?search=${search}`);
  }
 
  static getUsers(search, dealerId) {
    const dealerParam = dealerId ? `&dealerId=${dealerId}` : '';
    return get(`${url}/users?search=${search}${dealerParam}`);
  }

  static getUserPartners(search) {
    return get(`${url}/userPartners?search=${search}`);
  }

  static getUserAssociatedPartners() {
    return get(`${url}/user/associated-partners`);
  }

  static getPartners(search) {
    return get(`${url}/partners?search=${search}`);
  }

  static getDealer(dealerId) {
    return get(`${url}/dealers/${dealerId}`);
  }

  static getUser(userId) {
    return get(`${url}/users/${userId}`);
  }

  static getUserPartner(partnerId) {
    return get(`${url}/userPartner/${partnerId}`);
  }

  static getAccountManagers(search) {
    return get(`${url}/accountManagers?search=${search}`);
  }

  static getAccountManager(accountManagerId) {
    return get(`${url}/accountManagers/${accountManagerId}`);
  }

  static getOfferPriorities() {
    return get(`${url}/leasingoffers/offerpriorities`);
  }

  static getTransactionCategories() {
    return get(`${url}/leasingoffers/transactionCategories`);
  }

  static getInvoicingExchangeRates = () => {
    return get(`${url}/leasingoffers/invoicingExchangeRates`);
  };

  static getReferenceInterests = () => {
    return get(`${url}/leasingoffers/reference-interests`);
  };

  static getAcquisitionExchangeRates = () => {
    return get(`${url}/leasingoffers/acquisitionExchangeRates`);
  };

  static getCreditFinancingLines = () => {
    return get(`${url}/leasingoffers/creditFinancingLines`);
  };

  static getInvoicingBankList = () => {
    return get(`${url}/leasingoffers/client-invoicing-banks`);
  };

  static getScheduleTypes = () => {
    return get(`${url}/leasingoffers/scheduleTypes`);
  };

  static getLegalForms = () => {
    return get(`${url}/legalforms`);
  };

  static getDimensionPeriods = () => {
    return get(`${url}/dimensionperiods`);
  };

  static getScoringCategoryOptions() {
    return get(`${url}/leasingdocument/scoring/options`);
  }

  static getCommissionTypes() {
    return get(url + "/dictionary/commissionTypes");
  }

  static getLeasingExpenseTypes = (documentId, siteId) => {
    return get(`${url}/dictionary/${documentId}/${siteId}/financial-product-leasing-expense-types`);
  };

  static filterPartners(filters) {
    const qs = objToQueryString({ ...filters });
    return get(`${url}/dictionary/partners?${qs}`);
  }

  static getCountries() {
    return get(`${masterPartnerUrl}/dictionaries/countries`);
  }

  static getCounties() {
    return get(`${masterPartnerUrl}/dictionaries/-1/counties`);
  }

  static getCities() {
    return get(`${masterPartnerUrl}/dictionaries/-1/cities`);
  }

  static getPartnerRoles = () => {
    return get(`${url}/dictionary/partner-roles`);
  };

  static getContractTypes() {
    return get(`${url}/dictionary/contract-types`);
  }

  static getAssetCategories = () => {
    return get(`${url}/dictionary/asset-categories`);
  };

  static getAssetClassifications = () => {
    return get(`${url}/dictionary/asset-classifications`);
  };

  static getPartnerPositions = () => {
    return get(`${url}/dictionary/partner-positions`);
  };

  static getContactModeTypes() {
    return get(`${url}/dictionary/contact-mode-types`);
  }
}

export default DictionariesApi;
